export const ko = {
  // Navigation
  home: "홈",
  about: "소개",
  tours: "투어",
  deals: "특가",
  testimonials: "후기",
  blog: "블로그",
  contact: "연락처",
  
  // Company
  companyName: "Lanka Travel",
  
  // Home page
  welcomeTitle: "스리랑카에 오신 것을 환영합니다",
  welcomeSubtitle: "인도양의 진주라고 불리는 아름다움을 발견하세요",
  exploreButton: "투어 둘러보기",
  learnMoreButton: "더 알아보기",
  
  // About page
  aboutTitle: "회사 소개",
  aboutSubtitle: "스리랑카에서 신뢰할 수 있는 여행 파트너",
  aboutDescription: "우리는 맑은 해변부터 고대 사원까지 스리랑카 전역에서 잊을 수 없는 여행 경험을 만드는 전문가입니다.",
  
  // Tours page
  toursTitle: "투어 상품",
  toursSubtitle: "놀라운 여행지를 발견하세요",
  bookNow: "지금 예약",
  viewDetails: "상세보기",
  
  // Contact page
  contactTitle: "연락처",
  contactSubtitle: "저희에게 연락하세요",
  name: "이름",
  email: "이메일",
  message: "메시지",
  send: "메시지 보내기",
  phone: "전화번호",
  address: "주소",
  
  // Testimonials
  testimonialsTitle: "고객 후기",
  testimonialsSubtitle: "실제 여행자들의 진짜 경험담",
  
  // Blog
  blogTitle: "여행 블로그",
  blogSubtitle: "최신 여행 이야기와 팁",
  readMore: "더 읽기",
  
  // Common
  loading: "로딩 중...",
  error: "오류가 발생했습니다",
  success: "성공!",
  close: "닫기",
  submit: "제출",
  cancel: "취소",
  
  // Language selector
  selectLanguage: "언어 선택",
  english: "English",
  sinhala: "සිංහල",
  korean: "한국어",
  italian: "Italiano",
  
  // About Us Page
  whyChooseTitle: "왜 스리 야트라 여행사를 선택해야 할까요?",
  whyChooseSubtitle: "우리는 뛰어난 서비스와 맞춤형 패키지로 최고의 여행 경험을 제공하기 위해 노력합니다.",
  personalizedTitle: "맞춤형 여행 계획",
  personalizedDesc: "각 여행을 고유한 요구에 맞게 조정하여 독특한 여행 경험을 보장합니다.",
  customerSupportTitle: "24/7 고객 지원",
  customerSupportDesc: "우리의 전담 여행 전문가들이 언제든지 모든 문의에 도움을 드릴 수 있습니다.",
  destinationsTitle: "엄선된 여행지",
  destinationsDesc: "잊을 수 없는 경험을 제공하기 위해 신중하게 선택된 최고의 여행지를 탐험하세요.",
  priceGuaranteeTitle: "최고 가격 보장",
  priceGuaranteeDesc: "여행 경험의 품질을 타협하지 않고 경쟁력 있는 가격을 제공합니다.",
  luxuryTitle: "럭셔리 & 편안함",
  luxuryDesc: "궁극적인 편안함을 위한 고급 숙박 시설과 원활한 여행 준비를 즐기세요.",
  guidesTitle: "전문 투어 가이드",
  guidesDesc: "우리의 지식이 풍부하고 친근한 가이드들이 여행을 최대한 활용할 수 있도록 보장합니다.",
  
  // Contact Page
  getInTouchTitle: "스리 야트라 여행사와 연락하세요",
  loveToHearTitle: "여러분의 소식을 듣고 싶습니다",
  loveToHearDesc: "투어, 가격 또는 기타 모든 것에 대한 질문이 있으시면 저희 팀이 모든 질문에 답변할 준비가 되어 있습니다.",
  office: "사무실",
  phone: "전화",
  support: "지원",
  email: "이메일",
  officeAddress: "와타바게 정션, 파나두라, 스리랑카",
  phoneNumber: "+94 72 051 2976",
  supportNumber: "+94 72 051 2976",
  emailAddress: "lankatravelhub.lk@gmail.com",
  contactFormTitle: "메시지를 보내주세요",
  contactFormDesc: "아래 양식을 작성하시면 가능한 한 빨리 답변드리겠습니다.",
  namePlaceholder: "이름",
  emailPlaceholder: "이메일",
  phonePlaceholder: "전화번호",
  messagePlaceholder: "메시지",
  submitButton: "메시지 보내기",
  submitting: "전송 중...",
  messageSent: "메시지가 성공적으로 전송되었습니다!",
  messageError: "메시지 전송에 실패했습니다. 다시 시도해주세요.",
  
  // Testimonials Page
  customerReviewsTitle: "고객 후기",
  customerReviewsSubtitle: "저희와 함께 스리랑카를 탐험한 실제 여행자들의 진짜 경험담",
  
  // Blog Page
  travelBlogTitle: "여행 블로그",
  travelBlogSubtitle: "스리랑카에서의 모험에서 나온 최신 여행 이야기, 팁 및 통찰력",
  
  // Tours Page
  ourToursTitle: "투어 상품",
  ourToursSubtitle: "놀라운 여행지와 잊을 수 없는 경험을 발견하세요",
  
  // Deals Page
  specialDealsTitle: "특별 할인",
  specialDealsSubtitle: "최고의 투어에 대한 독점 제공 및 할인",
  
  // Tour Content
  culturalTourTitle: "스리랑카 문화 투어",
  culturalTourDesc: "이 문화 투어에서 스리랑카의 풍부한 유산과 역사적 장소를 경험하세요.",
  wildlifeTourTitle: "야생동물 사파리 모험",
  wildlifeTourDesc: "스리랑카의 유명한 야생동물 공원을 탐험하고 자연 서식지에서 이국적인 동물들을 목격하세요.",
  beachTourTitle: "해변 휴가",
  beachTourDesc: "맑은 물과 황금빛 모래가 있는 스리랑카의 가장 아름다운 해변에서 휴식을 취하세요.",
  hillCountryTourTitle: "언덕 지역 모험",
  hillCountryTourDesc: "스리랑카의 산, 폭포, 차 농장의 아름다운 경치를 발견하세요.",
  honeymoonTourTitle: "럭셔리 신혼여행 패키지",
  honeymoonTourDesc: "스리랑카 최고의 리조트에서 로맨틱하고 럭셔리한 신혼여행 경험을 즐기세요.",
  adventureTourTitle: "모험 & 트레킹 투어",
  adventureTourDesc: "스리랑카에서 스릴 넘치는 트레킹 모험과 야외 활동을 시작하세요.",
  
  // Deal Content
  exclusiveHoneymoonTitle: "독점 스리랑카 신혼여행 패키지",
  exclusiveHoneymoonDesc: "로맨틱한 휴가, 해변 리조트, 문화 경험과 함께 럭셔리한 신혼여행을 즐기세요.",
  adventureWildlifeTitle: "모험 & 야생동물 투어",
  adventureWildlifeDesc: "흥미진진한 사파리와 자연 탐험으로 스리랑카의 야생을 탐험하세요.",
  luxuryBeachTitle: "럭셔리 해변 휴가",
  luxuryBeachDesc: "최고의 해변에서 휴식을 취하고, 수상 스포츠를 즐기며, 최고 수준의 환대를 경험하세요.",
  culturalHeritageTitle: "문화 유산 투어",
  culturalHeritageDesc: "스리랑카의 유네스코 세계유산, 고대 사원, 활기찬 도시를 방문하세요.",
  budgetFamilyTitle: "저예산 가족 휴가",
  budgetFamilyDesc: "모든 연령대를 위한 흥미진진한 활동이 포함된 저렴한 가족 친화적 패키지.",
  ultimateAdventureTitle: "궁극의 모험 투어",
  ultimateAdventureDesc: "스리랑카의 아름다운 풍경에서 트레킹, 래프팅, 모험 스포츠.",
  
  // Blog Content
  exploringBeautyTitle: "스리랑카의 아름다움 탐험",
  exploringBeautyExcerpt: "이 포괄적인 여행 가이드에서 스리랑카의 숨막히는 풍경, 풍부한 역사, 문화적 경이를 발견하세요.",
  bestBeachesTitle: "스리랑카 최고의 해변",
  bestBeachesExcerpt: "황금빛 모래 해변부터 아름다운 청록색 바다까지, 완벽한 휴가를 위한 스리랑카 최고의 해변 목적지를 탐험하세요.",
  wildlifeSafariTitle: "야생동물 사파리 모험",
  wildlifeSafariExcerpt: "스리랑카의 유명한 국립공원에서 코끼리, 표범, 이국적인 새들을 발견하는 스릴을 경험하세요.",
  
  // Testimonial Content
  johnReview: "스리랑카 여행이 정말 환상적이었습니다! 계획과 조직이 완벽했고, 여행 내내 잘 돌봐주셨습니다. 스리 야트라 여행사를 강력히 추천합니다!",
  emmaReview: "정말 잊을 수 없는 경험이었습니다! 아름다운 해변부터 놀라운 문화 유적까지, 모든 것이 완벽하게 계획되었습니다. 다시 방문하고 싶습니다!",
  carlosReview: "제가 예약한 여행사 중 최고입니다! 모든 것이 잘 조직되었고, 가이드들이 지식이 풍부하고 친근했습니다. 놀라운 경험을 해주셔서 감사합니다!",
  sophiaReview: "원활하고 잊을 수 없는 여행이었습니다! 팀이 전문적이었고, 일정이 잘 생각되어 있었습니다. 스리랑카를 방문하는 모든 사람에게 스리 야트라 여행사를 강력히 추천합니다.",
  
  // Common Labels
  activities: "활동",
  duration: "기간",
  price: "가격",
  workingHours: "근무 시간",
  workingHoursText: "월요일 – 금요일: 오전 9:00 – 오후 6:00",
  
  // Highlights Tour
  fiveDayHighlightsTitle: "스리랑카 하이라이트",
  fiveDayHighlightsSubtitle: "하이라이트: 카투나야케, 시기리야, 캔디, 엘라, 갈레. 스리랑카의 필수 방문지를 통한 간결한 여행.",
  bookNow: "지금 예약",
  
  // Katunayake
  day1Title: "도착",
  katunayakeTitle: "카투나야케",
  katunayakeStay: "카투나야케 근처 편안한 숙박",
  katunayakeActivities: "활동",
  katunayakeArrival: "반다라나이케 국제공항 도착",
  katunayakeMeetGreet: "만남과 인사, 근처 숙소로 이동",
  katunayakeNegombo: "네고보 해변 선택 방문 (시간 허용시)",
  katunayakeRest: "비행 후 휴식",
  katunayakeLocation: "카투나야케 - 반다라나이케 국제공항",
  katunayakeDescription: "공항 근처 편리한 첫 밤으로 스리랑카 하이라이트를 시작하세요.",
  
  // Sigiriya
  day2Title: "시기리야",
  sigiriyaTitle: "시기리야",
  sigiriyaStay: "시기리야 게스트하우스",
  sigiriyaTransfer: "시기리야로 이동",
  sigiriyaClimb: "시기리야 바위 요새 등반",
  sigiriyaExplore: "수원과 프레스코 탐험",
  sigiriyaVillage: "마을 체험 또는 자전거 타기 (선택사항)",
  sigiriyaLocation: "시기리야 바위 요새",
  sigiriyaDescription: "장엄한 전망을 자랑하는 유네스코 세계문화유산.",
  
  // Kandy
  day3Title: "캔디",
  kandyTitle: "캔디",
  kandyStay: "캔디 호텔",
  kandyTransfer: "캔디로 이동",
  kandyTemple: "성치 불치 사원",
  kandyGardens: "페라데니야 왕립 식물원",
  kandyLake: "캔디 호수 산책과 현지 시장",
  kandyLocation: "성치 불치 사원, 캔디",
  kandyDescription: "신성한 유산과 울창한 정원을 가진 문화 수도.",
  
  // Ella
  day4Title: "엘라",
  ellaTitle: "엘라",
  ellaStay: "엘라의 아늑한 숙박",
  ellaTrain: "엘라로의 경치 좋은 기차 여행",
  ellaPeak: "리틀 아담스 피크 하이킹",
  ellaBridge: "나인 아치 다리 전망대",
  ellaExplore: "마을의 차 나라 분위기 탐험",
  ellaLocation: "엘라 근처 경치 좋은 기차",
  ellaDescription: "아름다운 산악 풍경을 자랑하는 시원한 기후의 언덕 휴양지.",
  
  // Galle
  day5Title: "갈레",
  galleTitle: "갈레",
  galleStay: "갈레 호텔 (또는 늦은 출발)",
  galleTransfer: "갈레로 이동",
  galleFort: "유네스코 등재 갈레 요새 탐험",
  galleLighthouse: "등대와 성벽 산책",
  galleCafes: "카페, 부티크, 해안 전망",
  galleContinue: "공항으로 계속 이동하거나 해변 숙박 연장",
  galleLocation: "갈레 요새 성벽과 등대",
  galleDescription: "하이라이트를 마무리하는 역사적인 해안의 매력",
  
  // Colombo Tour
  threeDayColomboTitle: "콜롬보 여행 - 스리랑카",
  threeDayColomboSubtitle: "럭셔리 호텔, 문화 방문, 쇼핑, 바다에서의 휴식을 통해 콜롬보의 최고를 경험하세요.",
  
  // Colombo
  dayOneTitle: "도착",
  dayTwoTitle: "시티 투어", 
  dayThreeTitle: "출발",
  
  // Day One Activities
  colomboArrival: "반다라나이케 국제공항 도착",
  colomboTransfer: "호텔로 이동 및 체크인",
  colomboFort: "콜롬보 요새 지역 탐험 – 식민지 건물, 시장, 쇼핑",
  colomboDinner: "호텔 레스토랑에서 저녁 식사 및 숙박.",
  
  // Day Two Activities
  colomboBreakfast: "호텔에서 아침 식사",
  colomboTemple: "간가라마야 사원 및 박물관 방문",
  colomboLunch: "현지 레스토랑에서 점심 식사",
  colomboMuseum: "국립 박물관 및 비하라마하데비 공원 오후 방문",
  colomboOvernight: "저녁 식사 및 숙박.",
  
  // Day Three Activities
  colomboRelax: "갈 페이스 그린에서 휴식하며 바다 감상",
  colomboShopping: "오델 또는 베어풋 갤러리에서 쇼핑",
  colomboPrepare: "출발 준비",
  colomboCheckout: "체크아웃 및 공항으로 이동.",
  
  // Hotels
  cinnamonGrand: "시나몬 그랜드 콜롬보",
  shangriLa: "샹그릴라 콜롬보",
  kingsbury: "더 킹스버리 콜롬보",
  
  // Tour Packages
  fiveDayBudgetPackTitle: "예산 패키지 (스리랑카 하이라이트)",
  fiveDayBudgetPackSubtitle: "하이라이트",
  fiveDayBudgetPackFeatures: "🏨 ✈ 🚗 🍽",
  fiveDayBudgetPackType: "예산",
  fiveDayBudgetPackHighlights: "하이라이트",
  fiveDayBudgetPackCulture: "문화",
  fiveDayBudgetPackHistory: "역사",
  fiveDayBudgetPackNature: "자연",
  fiveDayBudgetPackPrice: "1인당 US $650부터",
  moreInformation: "더 많은 정보 ➜",
  
  threeDayColomboCityTitle: "콜롬보 시티 체험",
  threeDayColomboCitySubtitle: "시티 투어",
  threeDayColomboCityFeatures: "🏨 ✈ 🚗 🍽",
  threeDayColomboCityType: "시티 투어",
  threeDayColomboCityCulture: "문화",
  threeDayColomboCityShopping: "쇼핑",
  threeDayColomboCityLuxury: "럭셔리 호텔",
  threeDayColomboCitySightseeing: "관광",
  threeDayColomboCityPrice: "1인당 US $350부터",
  
  familyTripTitle: "스리랑카 가족 여행",
  familyTripSubtitle: "가족 패키지",
  familyTripFeatures: "🏨 ✈ 🚗 🍽",
  familyTripWildlife: "야생동물",
  familyTripNature: "자연",
  familyTripCulture: "문화",
  familyTripHistory: "역사",
  familyTripPrice: "1인당 US $850부터",
  
  bestOfSriLankaTitle: "스리랑카 베스트",
  bestOfSriLankaSubtitle: "종합",
  bestOfSriLankaFeatures: "🏨 ✈ 🚗 🍽",
  bestOfSriLankaBeach: "해변",
  bestOfSriLankaWildlife: "야생동물",
  bestOfSriLankaNature: "자연",
  bestOfSriLankaCulture: "문화",
  bestOfSriLankaPrice: "1인당 US $1250부터",
  
  romanticGetawayTitle: "스리랑카 로맨틱 게토웨이",
  romanticGetawaySubtitle: "로맨틱 패키지",
  romanticGetawayFeatures: "🏨 ✈ 🚗 🍽",
  romanticGetawayNature: "자연",
  romanticGetawayBeach: "해변",
  romanticGetawayWildlife: "야생동물",
  romanticGetawayHistory: "역사",
  romanticGetawayPrice: "1인당 US $1700부터",
  
  // Why Choose Us
  whyChooseUsTitle: "왜 저희를 선택해야 할까요?",
  whyChooseUsSubtitle: "많은 사람들이 저희를 최고의 여행 목적지 관리 회사로 선택했으며, 다음 이유로 여러분도 저희를 선택하실 것입니다.",
  
  whyChooseUsReason1: "저희는 스리랑카의 최고 목적지 관리 회사 중 하나입니다.",
  whyChooseUsReason2: "저희는 스리랑카의 주요 투어 운영업체 중 하나입니다.",
  whyChooseUsReason3: "저희는 여행자와 여행 대리점에게 완전한 여행 패키지를 제공합니다.",
  whyChooseUsReason4: "저희는 스리랑카 관광에 대한 광범위한 지식을 가진 40명의 대표자로 구성된 열정적이고 전문적인 팀을 보유하고 있습니다.",
  whyChooseUsReason5: "저희는 스리랑카의 주요 여행 대리점 중 하나입니다.",
  whyChooseUsReason6: "저희는 고객에게 맞춤형 및 전문 투어를 제공합니다.",
  whyChooseUsReason7: "저희는 이국적인 목적지에 투어와 휴가 패키지를 제공하는 스리랑카의 주요 여행 대리점입니다.",
  whyChooseUsReason8: "저희는 고객에게 24/7 고객 지원을 제공합니다.",
  
  readMore: "더 읽기",
  
  // How It Works
  howItWorksTitle: "어떻게 작동하나요?",
  
  // Common UI elements
  days: "일",
  from: "부터",
  perPerson: "1인당",
  
  step1Title: "1. 지금 문의하기",
  step1Time: "5분",
  step1FillingForm: "웹 양식 작성",
  step1WebChat: "웹 실시간 채팅",
  step1Email: "이메일",
  step1Call: "전화",
  
  step2Title: "2. 여행 전문가와 연결",
  step2Time: "30분",
  step2Discuss: "요구사항 논의",
  step2FreeAdvice: "무료 전문 여행 조언",
  step2Support: "24/7 지원",
  
  step3Title: "3. 3가지 여행 옵션 수신",
  step3Discuss: "변경사항 논의",
  step3Finalise: "여행 계획 확정",
  step3Pay: "10% 지불",
  
  step4Title: "4. 여행 확인서 수신",
  step4FillingForm: "웹 양식 작성",
  step4Satisfaction: "100% 만족 보장",
  
  // Complete Sri Lanka Circuit Tour
  completeSriLankaTitle: "완전한 스리랑카 순회",
  completeSriLankaSubtitle: "포괄적",
  completeSriLankaFeatures: "🏨 ✈ 🚗 🍽",
  completeSriLankaType: "포괄적",
  completeSriLankaHighlights: "하이라이트",
  completeSriLankaCulture: "문화",
  completeSriLankaHistory: "역사",
  completeSriLankaNature: "자연",
  completeSriLankaBeach: "해변",
  completeSriLankaPrice: "1인당 US $1850부터",
  
  // Complete Sri Lanka Circuit Details
  completeSriLankaCircuitTitle: "완전한 스리랑카 순회",
  completeSriLankaCircuitSubtitle: "모든 주요 목적지를 다루는 포괄적인 여행으로 스리랑카의 완전한 아름다움을 경험하세요.",
  
  // Day 2 - Anuradhapura
  ancientCityTitle: "아누라다푸라",
  ancientCityStay: "아누라다푸라 호텔",
  ancientCityTransfer: "아누라다푸라로 이동",
  ancientCityExplore: "고대 유적과 스투파 탐험",
  ancientCityTemple: "스리 마하 보디 나무 방문",
  ancientCityMuseum: "고고학 박물관 방문",
  ancientCityLocation: "아누라다푸라 고대 도시",
  ancientCityDescription: "스리랑카의 고대 수도이자 유네스코 세계유산을 발견하세요.",
  
  // Nuwara Eliya
  day5Title: "누와라엘리야",
  nuwaraEliyaTitle: "누와라엘리야",
  nuwaraEliyaStay: "누와라엘리야 호텔",
  nuwaraEliyaTransfer: "누와라엘리야로 이동",
  nuwaraEliyaTea: "차 농장 및 공장 투어",
  nuwaraEliyaLake: "그레고리 호수 보트 타기",
  nuwaraEliyaExplore: "작은 잉글랜드 탐험",
  nuwaraEliyaLocation: "누와라엘리야 차 나라",
  nuwaraEliyaDescription: "작은 잉글랜드의 시원한 기후와 차 나라의 매력을 경험하세요.",
  
  // Ella (Second Day)
  day6Title: "엘라",
  day7Title: "엘라 연장",
  ellaWaterfall: "라바나 폭포 방문",
  ellaTea: "차 농장 투어",
  ellaRelax: "휴식과 산 경치 감상",
  ellaLocal: "현지 마을 체험",
  ellaDay2Description: "폭포와 차 나라를 탐험하기 위한 엘라의 두 번째 날.",
  
  // Mirissa
  day8Title: "미리사",
  mirissaTitle: "미리사",
  mirissaStay: "미리사 해변 리조트",
  mirissaTransfer: "미리사로 이동",
  mirissaBeach: "미리사 해변에서 휴식",
  mirissaWhale: "고래 관찰 투어 (계절적)",
  mirissaRelax: "해변 휴식과 일몰",
  mirissaLocation: "미리사 해변",
  mirissaDescription: "아름다운 해변과 고래 관찰 기회를 즐기세요.",
  
  // Mirissa (Second Day)
  day9Title: "미리사 연장",
  mirissaSnorkel: "스노클링과 수상 스포츠",
  mirissaDiving: "스쿠버 다이빙 (선택사항)",
  mirissaSunset: "일몰 해변 산책",
  mirissaDay2Description: "수상 활동과 해변 휴식을 위한 미리사의 두 번째 날.",
  
  // Galle
  day10Title: "갈레",
  
  // Galle (Second Day)
  day11Title: "갈레 연장",
  galleShopping: "갈레 요새에서 쇼핑",
  galleMuseum: "갈레 해양 박물관 방문",
  galleBeach: "우나와투나에서 해변 시간",
  galleDining: "요새 레스토랑에서 식사",
  galleDay2Description: "역사적인 요새를 더 탐험하기 위한 갈레의 두 번째 날.",
  
  // Bentota
  day12Title: "벤토타",
  bentotaTitle: "벤토타",
  bentotaStay: "벤토타 리조트",
  bentotaTransfer: "벤토타로 이동",
  bentotaRiver: "벤토타 강 사파리",
  bentotaBeach: "해변 활동",
  bentotaSpa: "스파 및 웰니스 트리트먼트",
  bentotaLocation: "벤토타 해변 리조트",
  bentotaDescription: "강 활동과 함께 아름다운 해변 리조트에서 휴식하세요.",
  
  // Colombo
  day13Title: "콜롬보",
  colomboTitle: "콜롬보",
  colomboStay: "콜롬보 호텔",
  colomboTransfer: "콜롬보로 이동",
  colomboFort: "콜롬보 요새 탐험",
  colomboTemple: "간가라마야 사원 방문",
  colomboShopping: "오델과 베어풋에서 쇼핑",
  colomboLocation: "콜롬보 시",
  colomboDescription: "수도의 명소와 쇼핑을 탐험하세요.",
  
  // Departure
  day14Title: "출발",
  departureTitle: "출발",
  departureStay: "공항 호텔 또는 출발",
  departureBreakfast: "마지막 아침식사",
  departureShopping: "마지막 순간 쇼핑",
  departureTransfer: "공항으로 이동",
  departureAirport: "반다라나이케 국제공항에서 출발",
  departureLocation: "반다라나이케 국제공항",
  departureDescription: "공항 이동과 출발이 있는 마지막 날.",
  
  // Wildlife & Cultural Heritage Details
  wildlifeCulturalCircuitTitle: "야생동물 및 문화유산 투어",
  wildlifeCulturalCircuitSubtitle: "이 포괄적인 여행에서 스리랑카의 야생동물, 고대 도시, 문화유산을 경험하세요.",
  
  // Day 2 - Udawalawe
  udawalaweTitle: "우다왈라웨",
  udawalaweStay: "우다왈라웨 사파리 로지",
  udawalaweTransfer: "우다왈라웨로 이동",
  udawalaweSafari: "우다왈라웨 국립공원 사파리",
  udawalaweElephants: "코끼리 관찰 및 사진 촬영",
  udawalaweBirds: "조류 관찰 투어",
  udawalaweLocation: "우다왈라웨 국립공원",
  udawalaweDescription: "자연 서식지에서 코끼리, 새, 기타 동물들과 함께 스리랑카의 야생동물을 경험하세요.",
  
  // Day 3 - Ella
  ellaWildlifeTitle: "엘라",
  ellaWildlifeStay: "엘라 호텔",
  ellaWildlifeTransfer: "엘라로 이동",
  ellaWildlifeTrain: "엘라로 가는 경치 좋은 기차 여행",
  ellaWildlifePeak: "리틀 아담스 피크 하이킹",
  ellaWildlifeBridge: "나인 아치 브리지 전망대",
  ellaWildlifeLocation: "엘라 힐 스테이션",
  ellaWildlifeDescription: "장관의 산 경치와 차 농장과 함께 아름다운 산간 지역을 탐험하세요.",
  
  // Day 4 - Nuwara Eliya
  nuwaraEliyaWildlifeTitle: "누와라엘리야",
  nuwaraEliyaWildlifeStay: "누와라엘리야 호텔",
  nuwaraEliyaWildlifeTransfer: "누와라엘리야로 이동",
  nuwaraEliyaWildlifeTea: "차 농장 및 공장 투어",
  nuwaraEliyaWildlifeLake: "그레고리 호수 보트 타기",
  nuwaraEliyaWildlifeExplore: "리틀 잉글랜드 탐험",
  nuwaraEliyaWildlifeLocation: "누와라엘리야 차의 나라",
  nuwaraEliyaWildlifeDescription: "리틀 잉글랜드의 시원한 기후와 차의 나라의 매력을 경험하세요.",
  
  // Day 5 - Kandy
  kandyWildlifeTitle: "캔디",
  kandyWildlifeStay: "캔디 호텔",
  kandyWildlifeTransfer: "캔디로 이동",
  kandyWildlifeTemple: "성치 사리 사원",
  kandyWildlifeGardens: "로얄 식물원",
  kandyWildlifeLake: "캔디 호수 산책",
  kandyWildlifeLocation: "성치 사리 사원",
  kandyWildlifeDescription: "신성한 유산과 무성한 정원이 있는 문화 수도.",
  
  // Day 6 - Sigiriya
  sigiriyaWildlifeTitle: "시기리야",
  sigiriyaWildlifeStay: "시기리야 호텔",
  sigiriyaWildlifeTransfer: "시기리야로 이동",
  sigiriyaWildlifeClimb: "시기리야 록 포트레스 등반",
  sigiriyaWildlifeExplore: "수원과 프레스코 탐험",
  sigiriyaWildlifeVillage: "마을 체험 또는 자전거 타기 (선택사항)",
  sigiriyaWildlifeLocation: "시기리야 록 포트레스",
  sigiriyaWildlifeDescription: "파노라믹 전망이 있는 상징적인 유네스코 세계유산.",
  
  // Day 7 - Anuradhapura
  anuradhapuraWildlifeTitle: "아누라다푸라",
  anuradhapuraWildlifeStay: "아누라다푸라 호텔",
  anuradhapuraWildlifeTransfer: "아누라다푸라로 이동",
  anuradhapuraWildlifeExplore: "고대 유적과 스투파 탐험",
  anuradhapuraWildlifeTemple: "스리 마하 보디 나무 방문",
  anuradhapuraWildlifeMuseum: "고고학 박물관 방문",
  anuradhapuraWildlifeLocation: "아누라다푸라 고대 도시",
  anuradhapuraWildlifeDescription: "스리랑카의 고대 수도이자 유네스코 세계유산을 발견하세요.",
  
  // Day 8 - Polonnaruwa
  polonnaruwaTitle: "폴론나루와",
  polonnaruwaStay: "폴론나루와 호텔",
  polonnaruwaTransfer: "폴론나루와로 이동",
  polonnaruwaExplore: "고대 유적 탐험",
  polonnaruwaGalVihara: "갈 비하라 방문",
  polonnaruwaMuseum: "폴론나루와 박물관 방문",
  polonnaruwaLocation: "폴론나루와 고대 도시",
  polonnaruwaDescription: "잘 보존된 유적과 조각상과 함께 고대 수도를 탐험하세요.",
  
  // Day 9 - Trincomalee
  trincomaleeTitle: "트린코말리",
  trincomaleeStay: "트린코말리 호텔",
  trincomaleeTransfer: "트린코말리로 이동",
  trincomaleeBeach: "닐라벨리 해변에서 휴식",
  trincomaleeWhale: "고래 관찰 투어 (계절적)",
  trincomaleeFort: "프레드릭 요새 탐험",
  trincomaleeLocation: "닐라벨리 해변, 트린코말리",
  trincomaleeDescription: "아름다운 해변과 고래 관찰 기회를 즐기세요.",
  
  // Day 10 - Colombo
  colomboWildlifeTitle: "콜롬보",
  colomboWildlifeStay: "콜롬보 호텔",
  colomboWildlifeTransfer: "콜롬보로 이동",
  colomboWildlifeFort: "콜롬보 요새 탐험",
  colomboWildlifeTemple: "간가라마야 사원 방문",
  colomboWildlifeShopping: "오델과 베이라풋 갤러리에서 쇼핑",
  colomboWildlifeLocation: "콜롬보 시",
  colomboWildlifeDescription: "수도의 명소와 쇼핑을 탐험하세요.",
  
  // Wildlife Cultural Tour
  wildlifeCulturalTitle: "야생동물 및 문화유산 투어",
  wildlifeCulturalType: "야생동물 및 문화",
  wildlifeCulturalHighlights: "하이라이트",
  wildlifeCulturalWildlife: "야생동물",
  wildlifeCulturalCulture: "문화",
  wildlifeCulturalHistory: "역사",
  wildlifeCulturalNature: "자연",
  
  // Hill Country Beach Tour
  hillCountryBeachTitle: "산간 지역 및 해변 투어",
  hillCountryBeachType: "산간 지역 및 해변",
  hillCountryBeachHighlights: "하이라이트",
  hillCountryBeachNature: "자연",
  hillCountryBeachBeach: "해변",
  hillCountryBeachCulture: "문화",
  hillCountryBeachAdventure: "모험",
  
  // Cultural Triangle Beach Tour
  culturalTriangleBeachTitle: "문화 삼각지대 및 해변 투어",
  culturalTriangleBeachType: "문화 삼각지대 및 해변",
  culturalTriangleBeachHighlights: "하이라이트",
  culturalTriangleBeachCulture: "문화",
  culturalTriangleBeachHistory: "역사",
  culturalTriangleBeachBeach: "해변",
  culturalTriangleBeachRelaxation: "휴식",
  
  // Package 1
  package1Title: "패키지 1 - 스리랑카",
  package1Duration: "4박 5일",
  package1Charges: "호텔 및 교통비만",
  package1Hotel: "4성급 호텔 포함 침대, 저녁 식사 및 조식",
  package1Price: "2인당 1일 $335",
  package1Day1: "1일차",
  package1Day1Activity1: "핀나왈라",
  package1Day1Activity2: "캔디 (캔디 댄스)",
  package1Day2: "2일차",
  package1Day2Activity1: "넬리가라",
  package1Day2Activity2: "캔디 사원",
  package1Day3: "3일차",
  package1Day3Activity1: "가달라데니야, 암박케",
  package1Day3Activity2: "페라데니야 정원",
  package1Day4: "4일차",
  package1Day4Activity1: "왁스 박물관 캔디",
  package1Day4Activity2: "보석, 향신료 및 바틱 쇼핑",
  package1Activities: "활동",
  
  // Package 2
  package2Title: "패키지 2 - 스리랑카",
  package2Duration: "4박 5일",
  package2Charges: "호텔 및 교통비만",
  package2Hotel: "4성급 호텔 포함 침대, 저녁 식사 및 조식",
  package2Price: "2인당 1일 $335",
  package2Day1: "1일차",
  package2Day1Activity1: "핀나왈라",
  package2Day1Activity2: "캔디 사원",
  package2Day1Activity3: "캔디 댄스",
  package2Day2: "2일차",
  package2Day2Activity1: "보석, 향신료 및 바틱 쇼핑",
  package2Day2Activity2: "페라데니야 정원",
  package2Day2Activity3: "넬리가라",
  package2Day3: "3일차",
  package2Day3Activity1: "누와라엘리야",
  package2Day3Activity2: "그레고리 공원",
  package2Day4: "4일차",
  package2Day4Activity1: "암베웰라 농장",
  package2Activities: "활동",
  
  // Package 3
  package3Title: "패키지 3 - 스리랑카",
  package3Duration: "4박 5일",
  package3Charges: "호텔 및 교통비만",
  package3Hotel: "4성급 호텔 포함 침대, 저녁 식사 및 조식",
  package3Price: "2인당 1일 $335",
  package3Day1: "1일차",
  package3Day1Activity1: "핀나왈라",
  package3Day1Activity2: "캔디 사원",
  package3Day1Activity3: "캔디 댄스",
  package3Day2: "2일차",
  package3Day2Activity1: "페라데니야 정원",
  package3Day2Activity2: "넬리가라",
  package3Day2Activity3: "보석, 향신료 및 바틱 쇼핑",
  package3Day3: "3일차",
  package3Day3Activity1: "시기리야",
  package3Day4: "4일차",
  package3Day4Activity1: "담불라 사원",
  package3Day4Activity2: "담불라 마을 사원",
  package3Activities: "활동",
  
  
  // Package tags
  hotel: "호텔",
  transport: "교통",
  cultural: "문화",
  shopping: "쇼핑",
  hillCountry: "산악 지역",
  teaPlantations: "차 재배지",
  sigiriya: "시기리야",
  heritageSites: "유산지",
  safari: "사파리",
  wildlife: "야생동물",
  
  // Package titles (short version for cards)
  package1: "패키지 1",
  package2: "패키지 2",
  package3: "패키지 3",

  // Package 4
  package4Title: "Package 4 (Couples) - Sri Lanka",
  package4Duration: "5 nights 6 days",
  package4Charges: "Hotel and transport charges only",
  package4Hotel: "4 star hotel include bed, dinner & breakfast",
  package4Price: "Two person per day $335",
  package4Locations: [
    {
      name: "📍 Bentota",
      activities: [
        { title: "Bentota River Boat Safari", desc: "Enjoy a relaxing boat ride through scenic mangroves where you can spot birds, monitor lizards, and other wildlife." }
      ]
    },
    {
      name: "📍 Mirissa",
      activities: [
        { title: "Mirissa Beach", desc: "Unwind on a beautiful sandy beach with clear waters, perfect for swimming and relaxing under the sun." },
        { title: "Coconut Tree Hill", desc: "Visit a famous viewpoint lined with coconut trees, offering stunning ocean views and great photo opportunities." },
        { title: "Parrot Rock", desc: "Walk across shallow waters to this small rock island for a unique perspective of Mirissa Beach." }
      ]
    },
    {
      name: "📍 Ella",
      activities: [
        { title: "Nine Arch Bridge", desc: "See the iconic stone bridge surrounded by lush greenery, a must-visit spot for photos and train sightings." },
        { title: "Ravana Pool Club", desc: "Relax in a stylish pool setting with mountain views, music, and a laid-back atmosphere." },
        { title: "Ravana Ella Waterfall", desc: "Stop by this impressive waterfall cascading down rocky cliffs, perfect for photos and a quick refresh." }
      ]
    },
    {
      name: "📍 Nuwara Eliya",
      activities: [
        { title: "Gregory Lake", desc: "Spend time by a peaceful lake where you can enjoy cool weather, boat rides, and outdoor activities." },
        { title: "Victoria Park", desc: "Take a relaxing walk through a well-kept park filled with colorful flowers and natural beauty." }
      ]
    }
  ],
  package4Activities: "Activities",
  package4: "Package 4 (Couples)",

  // Package 5
  package5Title: "Package 5 - Sri Lanka",
  package5Duration: "6 nights 7 days",
  package5Charges: "Hotel and transport charges only",
  package5Hotel: "4 star hotel include bed, dinner & breakfast",
  package5Price: "Two person per day $335",
  package5Locations: [
    {
      name: "📍 Kitulgala",
      activities: [
        { title: "White Water Rafting", desc: "Experience an exciting rafting adventure through river rapids surrounded by lush rainforest scenery." }
      ]
    },
    {
      name: "📍 Ella",
      activities: [
        { title: "Nine Arch Bridge", desc: "Visit one of Sri Lanka’s most famous landmarks, ideal for photography and watching trains pass through." },
        { title: "Ravana Pool Club", desc: "Enjoy a refreshing break at a scenic pool club with great views and a relaxing vibe." },
        { title: "Ravana Ella Waterfall", desc: "Admire the beauty of this popular waterfall and take memorable photos in a natural setting." }
      ]
    },
    {
      name: "📍 Arugam Bay",
      activities: [
        { title: "Arugam Bay Beach", desc: "Relax on a world-famous beach known for its laid-back vibe, golden sand, and surf-friendly waves." },
        { title: "Elephant Rock", desc: "Take a short tuk ride and hike to this viewpoint for stunning sunrise or sunset views over the coastline." }
      ]
    },
    {
      name: "📍 Yala",
      activities: [
        { title: "Yala National Park Safari", desc: "Go on a thrilling safari to spot wildlife such as elephants, leopards, and a variety of birds." },
        { title: "Jeep Safari Experience", desc: "Explore the park in a 4x4 jeep with an experienced driver for the best chance of seeing animals up close." }
      ]
    },
    {
      name: "📍 Bentota (Return Stop)",
      activities: [
        { title: "Bentota Boat Ride", desc: "Enjoy another calm and scenic river boat ride, perfect for relaxing before heading to the airport." }
      ]
    }
  ],
  package5Activities: "Activities",
  package5: "Package 5",

};
